import { Button, Typography, TextField, Box, BDSProvider } from '@barracuda-internal/bds-core-v2';
import React, { ReactElement, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { useAppToolchain } from 'src/hooks/useAppToolchain';
import { useApiRequest } from 'src/hooks/useApi';
import useAuth from 'src/hooks/useAuth';
import { useNavigate } from 'react-router-dom';

interface Props {}

function AccountUpdate({}: Props): ReactElement {
	
	const navigate = useNavigate();
	const { api } = useAppToolchain();
	const { auth } = useAuth();
	const [accountName, setAccountName] = useState(auth.accountDetails.account.name ?? '');
	const [doUpdate, setDoUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const [updateStatus, req, error] = useApiRequest(
		doUpdate &&
			(() => {
				setLoading(true);
				let body = [{ "op": "replace", "path": "/name", "value": accountName.trim() }]
				return api
					.updateAccount(
						auth.accountDetails.account.id,
						body
					)
					.then((res) => {
						navigate(0);
						setLoading(false);
					})
					.catch((res) => {
						setLoading(false);
					}).finally(() => {
						setDoUpdate(false);
					})
			}),
		[doUpdate],
		() => {},
	);
	const handleAccountNameChange = (e) => {
        setAccountName(e.target.value);
	};
	return (
		<BDSProvider>
		<Box>
			<Typography
				variant="h3"
				color="textPrimary"
				sx={{ mb: 2 }}
			>
				Tenant Information
			</Typography>

			<Box sx={{ ml: 2, mt: 4, mb: 4 }}>
				
				<Grid container spacing={1}>
				<Grid item xs={9}>
					<TextField
						fullWidth
						size="small"
						label="Tenant Name"
						required
						onChange={handleAccountNameChange}
						value={accountName}
						variant="outlined"
						inputProps={{ maxLength: 30 }}
					/>
					</Grid>
					<Grid item xs={3}>
						<Button
							variant="outlined"
							onClick={() => setDoUpdate(true)}
							color="secondary"
							disabled={accountName.trim() === ''}
						>
							Update
						</Button>
					</Grid>
					
				</Grid>
			</Box>
		</Box>
		</BDSProvider>
	);
}

export default AccountUpdate;
